import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Check, ArrowRight, CreditCard, Clock, Zap, Layers } from 'lucide-react';
export const Pricing = () => {
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-662">
      <Navbar data-id="element-663" />
      <main data-id="element-664">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-24 lg:py-32" data-id="element-665">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.05)_0,_transparent_70%)]" data-id="element-666"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-667"></div>
          {/* Decorative elements */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/5 rounded-full filter blur-3xl" data-id="element-668"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-zinc-800/20 rounded-full filter blur-3xl" data-id="element-669"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-670">
            <div className="max-w-4xl mx-auto text-center" data-id="element-671">
              <div className="inline-block px-4 py-1 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-6" data-id="element-672">
                <span className="text-zinc-400 font-['Space_Grotesk'] text-sm tracking-wider" data-id="element-673">
                  TRANSPARENT PRICING
                </span>
              </div>
              <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-light mb-8 leading-tight" data-id="element-674">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-zinc-400" data-id="element-675">
                  Pricing
                </span>
              </h1>
              <p className="font-['Space_Grotesk'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-676">
                Simple, conversation-based pricing designed to scale with your
                firm's needs.
              </p>
            </div>
          </div>
        </section>
        {/* Main Content */}
        <section className="relative py-20" data-id="element-677">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0,_transparent_50%)]" data-id="element-678"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-679">
            <div className="max-w-4xl mx-auto" data-id="element-680">
              {/* Introduction Section */}
              <div className="mb-24 relative" data-id="element-681">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-682"></div>
                <div className="bg-gradient-to-br from-zinc-900/80 to-black/80 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-683">
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-8" data-id="element-684">
                    Simple{' '}
                    <span className="text-white" data-id="element-685">Subscription Model</span>
                  </h2>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-686">
                    We've designed our pricing to be a simple monthly
                    subscription that covers your minimum needs and scales based
                    on the number of conversations we handle for you.
                  </p>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-687">
                    Our pricing is channel-agnostic — it doesn't matter whether
                    conversations come through your website, phone calls, or
                    message conversations.
                  </p>
                  <div className="grid md:grid-cols-2 gap-6 mt-10" data-id="element-688">
                    <div className="bg-black/40 p-6 rounded-sm" data-id="element-689">
                      <div className="flex items-center mb-4" data-id="element-690">
                        <CreditCard size={24} className="text-white mr-3" data-id="element-691" />
                        <h3 className="font-['Playfair_Display'] text-xl" data-id="element-692">
                          AI Conversations
                        </h3>
                      </div>
                      <p className="text-white font-['Space_Grotesk'] text-lg font-semibold mt-1" data-id="element-693">
                        $4 per conversation
                      </p>
                      <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-694">
                        Whether AI is talking to a client, a member of your
                        team, or interacting with 3rd party software.
                      </p>
                    </div>
                    <div className="bg-black/40 p-6 rounded-sm" data-id="element-695">
                      <div className="flex items-center mb-4" data-id="element-696">
                        <Clock size={24} className="text-white mr-3" data-id="element-697" />
                        <h3 className="font-['Playfair_Display'] text-xl" data-id="element-698">
                          Human Conversations
                        </h3>
                      </div>
                      <p className="text-white font-['Space_Grotesk'] text-lg font-semibold" data-id="element-699">
                        $3 per minute
                      </p>
                      <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-700">
                        For when your clients need the human touch from our
                        expert intake specialists.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Subscription Section */}
              <div className="mb-24 relative" data-id="element-701">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-702"></div>
                <div className="flex items-center mb-8" data-id="element-703">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-704">
                    <CreditCard size={24} className="text-white" data-id="element-705" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-706">
                    Core <span className="text-white" data-id="element-707">Offering</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-708">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-709">
                    <div className="inline-block px-4 py-1 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6" data-id="element-710">
                      <span className="text-white font-['Space_Grotesk'] text-sm tracking-wider" data-id="element-711">
                        EARLY BIRD PRICING
                      </span>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-end gap-8 mb-10" data-id="element-712">
                      <div data-id="element-713">
                        <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mb-2" data-id="element-714">
                          Monthly subscription
                        </p>
                        <div className="flex items-baseline" data-id="element-715">
                          <span className="font-['Playfair_Display'] text-5xl font-light text-white" data-id="element-716">
                            $800
                          </span>
                          <span className="text-zinc-400 font-['Space_Grotesk'] ml-2" data-id="element-717">
                            /month
                          </span>
                        </div>
                        <p className="text-zinc-300 font-['Space_Grotesk'] text-sm mt-2" data-id="element-718">
                          Includes 200 conversations
                        </p>
                        <p className="text-zinc-300 font-['Space_Grotesk'] text-sm mt-1" data-id="element-719">
                          +$4/conversation overage
                        </p>
                      </div>
                      <div className="md:ml-12" data-id="element-720">
                        <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mb-2" data-id="element-721">
                          Regular pricing
                        </p>
                        <div className="flex items-baseline" data-id="element-722">
                          <span className="font-['Playfair_Display'] text-3xl font-light text-zinc-400 line-through" data-id="element-723">
                            $1600
                          </span>
                          <span className="text-zinc-500 font-['Space_Grotesk'] ml-2" data-id="element-724">
                            /month
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-white/10 pt-6 mt-6" data-id="element-725">
                      <p className="text-zinc-300 font-['Space_Grotesk'] text-lg mb-4" data-id="element-726">
                        No commitments or contracts required.
                      </p>
                      <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center mt-4" data-id="element-727">
                        Get Started
                        <ArrowRight size={18} className="ml-2" data-id="element-728" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* Conversations Defined Section */}
              <div className="mb-24 relative" data-id="element-729">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-730"></div>
                <div className="flex items-center mb-8" data-id="element-731">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-732">
                    <Layers size={24} className="text-white" data-id="element-733" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-734">
                    Conversations <span className="text-white" data-id="element-735">Defined</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-736">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-737">
                    <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8" data-id="element-738">
                      A conversation is counted as any of the following:
                    </p>
                    <div className="grid md:grid-cols-2 gap-6" data-id="element-739">
                      <div className="flex" data-id="element-740">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-741">
                          <Check size={16} className="text-white" data-id="element-742" />
                        </div>
                        <div data-id="element-743">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-744">
                            AI Phone Call
                          </h3>
                          <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-745">
                            One complete AI phone call with a lead
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-746">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-747">
                          <Check size={16} className="text-white" data-id="element-748" />
                        </div>
                        <div data-id="element-749">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-750">
                            AI Webchat
                          </h3>
                          <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-751">
                            One AI webchat conversation (up to 100 messages)
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-752">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-753">
                          <Check size={16} className="text-white" data-id="element-754" />
                        </div>
                        <div data-id="element-755">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-756">
                            AI SMS Conversation
                          </h3>
                          <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-757">
                            One AI SMS conversation from a phone number (up to
                            100 messages)
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-758">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-759">
                          <Check size={16} className="text-white" data-id="element-760" />
                        </div>
                        <div data-id="element-761">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-762">
                            Email Notification
                          </h3>
                          <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-763">
                            One email notification to a member of your staff{' '}
                            <span className="text-white/90 bg-white/10 px-2 py-0.5 text-xs rounded" data-id="element-764">
                              Waived for Early Bird clients
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-765">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-766">
                          <Check size={16} className="text-white" data-id="element-767" />
                        </div>
                        <div data-id="element-768">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-769">
                            Human Phone Call
                          </h3>
                          <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-770">
                            One human phone call minute
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-771">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-772">
                          <Check size={16} className="text-white" data-id="element-773" />
                        </div>
                        <div data-id="element-774">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-775">
                            Integration Call
                          </h3>
                          <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-776">
                            One integration call with 3rd party software (e.g.,
                            put the transcript into Filevine)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Premium Section */}
              <div className="mb-24 relative" data-id="element-777">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-778"></div>
                <div className="flex items-center mb-8" data-id="element-779">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-780">
                    <Zap size={24} className="text-white" data-id="element-781" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-782">
                    Premium <span className="text-white" data-id="element-783">Options</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-784">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-785">
                    <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8" data-id="element-786">
                      Enhance your experience with premium add-ons tailored to
                      your firm's specific needs:
                    </p>
                    <div className="grid md:grid-cols-3 gap-6" data-id="element-787">
                      <div className="bg-black/40 p-6 rounded-sm" data-id="element-788">
                        <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-789">
                          Split Testing
                        </h3>
                        <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-790">
                          Compare performance between human and AI intake to
                          optimize your client acquisition strategy.
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm" data-id="element-791">
                        <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-792">
                          Integrations
                        </h3>
                        <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-793">
                          Connect with 3rd party software to streamline your
                          workflow and eliminate manual data entry.
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm" data-id="element-794">
                        <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-795">
                          Custom Development
                        </h3>
                        <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-796">
                          Tailored solutions designed specifically for your
                          firm's unique requirements and workflows.
                        </p>
                      </div>
                    </div>
                    <div className="mt-8 text-center" data-id="element-797">
                      <p className="text-zinc-300 font-['Space_Grotesk'] mb-6" data-id="element-798">
                        Contact us to discuss premium options and custom pricing
                        for your firm.
                      </p>
                      <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center" data-id="element-799">
                        Schedule a Consultation
                        <ArrowRight size={18} className="ml-2" data-id="element-800" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-801" />
    </div>;
};